import { Component, Inject } from '@angular/core';
// eslint-disable-next-line import/order
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SelectDialogData {
  title: string;
  question: string;
  list: Array<any>;
  accessor?: string;
  selected?: any;
  prompt?: string;
}

@Component({
  selector: 'app-select-dialog',
  templateUrl: './select-dialog.component.html',
  styleUrls: ['./select-dialog.component.scss']
})
export class SelectDialogComponent {
  constructor(private dialogRef: MatDialogRef<SelectDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: SelectDialogData) {}

  cancel() {
    this.dialogRef.close();
  }

  apply() {
    this.dialogRef.close(this.data.selected);
  }
}
